(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

/************************/
/* Global Configuration */
/************************/

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var GlobalConfig = {
		root: null,
		modalSelector: '',
		triggerSelectors: [],
		dismissSelectors: [],
		rootActiveClass: '',
		modalActiveClass: 'is-visible',
		dismissOnFocusLost: true
};

/********************/
/* Global Constants */
/********************/
var ID_POOL_PREFIX = 'modal-';
var DATA_PREFIX = 'data-modal-';

/*********************/
/* Private Variables */
/*********************/
// jQuery formatted selector to search for focusable items
var _focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
// store the item that has focus before opening the modal window
var _focusedElementBeforeModal;

var _modals = {};

// var _eventNamespace = 'm-';
var _idPool = 0;

/*************/
/* Polyfills */
/*************/
if (!Array.prototype.indexOf) {
		Array.prototype.indexOf = function (obj, fromIndex) {
				if (fromIndex == null) {
						fromIndex = 0;
				} else if (fromIndex < 0) {
						fromIndex = Math.max(0, this.length + fromIndex);
				}
				for (var i = fromIndex, j = this.length; i < j; i++) {
						if (this[i] === obj) return i;
				}
				return -1;
		};
}

// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {

		Array.prototype.map = function (callback, thisArg) {

				var T, A, k;

				if (this == null) {
						throw new TypeError(' this is null or not defined');
				}

				var O = Object(this);
				var len = O.length >>> 0;

				if (typeof callback !== 'function') {
						throw new TypeError(callback + ' is not a function');
				}

				if (arguments.length > 1) {
						T = thisArg;
				}

				A = new Array(len);

				k = 0;

				while (k < len) {

						var kValue, mappedValue;

						if (k in O) {
								kValue = O[k];
								mappedValue = callback.call(T, kValue, k, O);

								A[k] = mappedValue;
						}

						k++;
				}

				return A;
		};
}

/*********************/
/* Private Functions */
/*********************/
function extend(out) {
		out = out || {};
		for (var i = 1; i < arguments.length; i++) {
				if (!arguments[i]) {
						continue;
				}
				for (var key in arguments[i]) {
						if (arguments[i].hasOwnProperty(key) && arguments[i][key] !== undefined) {
								out[key] = arguments[i][key];
						}
				}
		}
		return out;
}

function cleanSelector(selector) {
		return selector.replace(/\W/g, '');
}

function matchSelector(elem, selector) {
		if ($) {
				return $(elem).is(selector);
		} else if (typeof selector === 'string') {
				return elementMatchesSelector.call(elem, selector);
		} else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object' && selector.length) {
				return selector.indexOf(elem) >= 0;
		} else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object' && selector.nodeType === 1) {
				return elem === selector;
		}
		return false;
}

function generateId() {
		var id;
		while (true) {
				id = ID_POOL_PREFIX + String(++_idPool);
				if (!_modals[id]) {
						break;
				}
		}
		return id;
}

function getModalId(elem) {
		var hasClass = false;
		var elemClasses = elem && elem.className && elem.className.split(' ') || [];

		for (var id in _modals) {
				var triggerSelectors = _modals[id].triggerSelectors.map(function (selector) {
						return selector.substring(1);
				});

				var dismissSelectors = _modals[id].dismissSelectors.map(function (selector) {
						return selector.substring(1);
				});

				if (!_modals[id].disable) {
						for (var i = 0, len = elemClasses.length; i < len; i++) {
								hasClass = triggerSelectors.indexOf(elemClasses[i]) === 0 || dismissSelectors.indexOf(elemClasses[i]) === 0;
								if (hasClass) {
										break;
								}
						}

						return id;
				}
		}
}

function hideModal(modalId) {
		var modal = _modals[modalId];
		var modalRoot;

		if (!modal) {
				return;
		}

		modalRoot = modal.root;

		modalRoot.setAttribute('data-modal', 'false');
		modalRoot.setAttribute('aria-hidden', 'false');
		modal.modalSelector[0].setAttribute('data-visible', 'false');
		modal.modalSelector[0].setAttribute('aria-hidden', 'true');
}

function setEmailLink(modal, email) {
		var button = $(modal.modalSelector[0]).find(".js-modalButton-agree");
		var fullEmail = "javascript:window.location.href='" + email + "';";

		document.getElementById("js-modal-agree-id").setAttribute("onClick", fullEmail);
}

function onModalActivatorPress(evt) {

		var target = this;
		var modalId = getModalId(target);
		var modal = _modals[modalId];
		var modalRoot;
		var modalData;

		if (!modal) {
				return;
		}

		modalRoot = modal.root;
		modalData = modalRoot && modalRoot.getAttribute('data-modal');

		if (modalData && modalData === 'true') {
				return;
		}

		evt.preventDefault();
		evt.stopPropagation();

		var email = $(this).attr("href");
		setEmailLink(modal, email);

		modalRoot.setAttribute('data-modal', 'true');
		modalRoot.setAttribute('aria-hidden', 'true');
		modal.modalSelector[0].setAttribute('data-email', target.getAttribute('href'));
		modal.modalSelector[0].setAttribute('data-visible', 'true');
		modal.modalSelector[0].setAttribute('aria-hidden', 'false');
}

function onModalDismissorPress(evt) {
		var target = this;
		var modalId = getModalId(target);

		evt.preventDefault();
		evt.stopPropagation();

		hideModal(modalId);
}

/****************/
/* Modal Object */
/****************/
var Modal = {
		init: function init(config) {
				var options = extend({}, GlobalConfig, config);
				var triggerSelectors = options.triggerSelectors || [];
				var dismissSelectors = options.dismissSelectors || [];

				triggerSelectors = triggerSelectors.join(', ');
				dismissSelectors = dismissSelectors.join(', ');

				$(document).on('click', triggerSelectors, onModalActivatorPress);
				$(document).on('click', dismissSelectors, onModalDismissorPress);
		},

		set: function set() {
				var modalId, config;

				if (_typeof(arguments[0]) === 'object') {
						config = arguments[0];
				} else if (typeof arguments[0] === 'string' && _typeof(arguments[1]) === 'object') {
						modalId = arguments[0];
						config = arguments[1];
						if (!_modals[modalId]) {
								throw new Error('Section "' + modalId + '" doesn\'t exist!');
						}
				} else {
						return;
				}

				for (var key in config) {
						if (GlobalConfig[key] !== undefined) {
								if (modalId) {
										_modals[modalId][key] = config[key];
								} else if (config[key] !== undefined) {
										GlobalConfig[key] = config[key];
								}
						}
				}

				if (modalId) {
						// remove "undefined" items
						_modals[modalId] = extend({}, _modals[modalId]);
				}
		},

		add: function add() {
				var modalId;
				var config = {};

				if (_typeof(arguments[0]) === 'object') {
						config = arguments[0];
				} else if (typeof arguments[0] === 'string' && _typeof(arguments[1]) === 'object') {
						modalId = arguments[0];
						config = arguments[1];
				}

				if (!modalId) {
						modalId = typeof config.id === 'string' ? config.id : generateId();
				}

				if (_modals[modalId]) {
						throw new Error('Modal "' + modalId + '" already exists!');
				}

				_modals[modalId] = {};

				Modal.set(modalId, config);
		},

		destroy: function destroy() {
				window.removeEventListener('keyup', onKeyUp);
				Modal.clear();
				_idPool = 0;
				_ready = false;
		},

		clear: function clear() {
				_modals = {};
				_modalCount = 0;
				_defaultModalId = '';
				_lastModalId = '';
		}

};

window.Modal = Modal;

/*********************/
/* jQuery Interface  */
/*********************/
if ($) {
		$.Modal = function () {
				Modal.init();

				if (arguments.length > 0) {
						if ($.isPlainObject(arguments[0])) {
								return Modal.add(arguments[0]);
						} else if ($.type(arguments[0]) === 'string' && $.isFunction(Modal[arguments[0]])) {
								return Modal[arguments[0]].apply(Modal, [].slice.call(arguments, 1));
						}
				}

				return $.extend({}, Modal);
		};

		$.fn.Modal = function () {
				var config;

				if ($.isPlainObject(arguments[0])) {
						config = arguments[0];
				} else {
						config = {
								modalSelector: arguments[0]
						};
				}

				config.modalSelector = this;
				config.root = config.root || document.body;

				if (config.id) {
						Modal.remove(config.id);
				}

				Modal.add(config);
				Modal.init(config);

				return this;
		};
}

},{}],2:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var GlobalConfig = {
  context: '.js-locationsListing',
  selector: 'noscript',
  imageClass: 'location-image location-image--thumb lazy-loaded',
  dataSource: 'data-src'
};

var _ready = false;
var _images = [];
var _imageCount = 0;

var LazyImageLoader = {
  init: function init(elem) {
    var context;
    if (!elem || elem.length === 0) {
      return;
    }

    if (!_ready) {
      if (typeof elem === 'string') {
        elem = document.querySelectorAll(elem);
      }

      context = elem;

      if (!context) {
        return;
      }

      for (var i = 0, len = context.length; i < len; i++) {
        _images = context[i].querySelectorAll(GlobalConfig.selector);
      }

      _ready = true;
    }
  },
  set: function set() {
    var sectionId, config;

    if (_typeof(arguments[0]) === 'object') {
      config = arguments[0];
    } else if (typeof arguments[0] === 'string' && _typeof(arguments[1]) === 'object') {
      sectionId = arguments[0];
      config = arguments[1];
      if (!_sections[sectionId]) {
        throw new Error('Section "' + sectionId + '" doesn\'t exist!');
      }
    } else {
      return;
    }

    for (var key in config) {
      if (GlobalConfig[key] !== undefined) {
        if (sectionId) {
          _sections[sectionId][key] = config[key];
        } else if (config[key] !== undefined) {
          GlobalConfig[key] = config[key];
        }
      }
    }

    if (sectionId) {
      // remove "undefined" items
      _sections[sectionId] = extend({}, _sections[sectionId]);
    }
  },
  add: function add() {
    var sectionId;
    var config = {};

    if (_typeof(arguments[0]) === 'object') {
      config = arguments[0];
    } else if (typeof arguments[0] === 'string' && _typeof(arguments[1]) === 'object') {
      sectionId = arguments[0];
      config = arguments[1];
    }

    LazyImageLoader.set(config);
  },
  loadImages: function loadImages() {
    [].forEach.call(_images, function (image) {
      var img = new Image();
      var src = image.getAttribute('data-src');
      var imgAlt = image.getAttribute('data-alt');

      img.setAttribute('data-src', '');
      img.setAttribute('class', '');
      img.setAttribute('alt', imgAlt);
      img.setAttribute('item-prop', 'image');
      image.parentNode.insertBefore(img, image);
      img.onload = function () {
        img.removeAttribute('data-src');
      };
      img.src = src;
    });
  }
};

window.LazyImageLoader = LazyImageLoader;

/*********************/
/* jQuery Interface  */
/*********************/
if ($) {
  $.LazyImageLoader = function () {
    if (arguments.length > 0) {
      if ($.isPlainObject(arguments[0])) {
        return LazyImageLoader.add(arguments[0]);
      } else if ($.type(arguments[0]) === 'string' && $.isFunction(LazyImageLoader[arguments[0]])) {
        return LazyImageLoader[arguments[0]].apply(LazyImageLoader, [].slice.call(arguments, 1));
      }
    }

    return $.extend({}, LazyImageLoader);
  };

  $.fn.LazyImageLoader = function () {
    var config;

    if ($.isPlainObject(arguments[0])) {
      config = arguments[0];
    } else {
      config = {
        id: arguments[0]
      };
    }

    config.selector = this;

    LazyImageLoader.init(config.selector);

    if (config.id) {
      LazyImageLoader.remove(config.id);
    }
    LazyImageLoader.add(config);
    LazyImageLoader.loadImages();

    return this;
  };
};

},{}],3:[function(require,module,exports){
"use strict";

jQuery.fn.InitializePage = function (option) {

    var defaults = {
        initialJsonData: null,
        serviceUrl: null
    };

    var option = $.extend({}, defaults, option);

    // Load JSON data from model
    var viewModelJs = JSON.parse(option.initialJsonData);
    var viewModel = ko.mapping.fromJS(viewModelJs);
    var pageContent = $(this);

    //Extending ViewModel
    viewModel.allResults = ko.observableArray();
    viewModel.visibleResults = ko.observableArray();
    viewModel.showMoreButton = ko.observable(true);
    viewModel.BusinessEmailLink = ko.observable();
    viewModel.BusinessPhoneLink = ko.observable();

    var initCount = viewModel.RelatedProfessionalInitialCount();
    if (viewModel.RelatedProfessionals().length > 0) {
        ko.mapping.fromJS(viewModel.RelatedProfessionals, {}, viewModel.allResults);

        if (viewModel.allResults().length <= initCount) {
            viewModel.showMoreButton(false);
            initCount = viewModel.allResults().length;
        }

        for (var i = 0; i < initCount; i++) {
            viewModel.visibleResults.push(viewModel.RelatedProfessionals()[i]);
        }
    }

    viewModel.LoadMore = function () {

        var skip = initCount;
        if (viewModel.allResults().length <= viewModel.visibleResults().length + skip) {
            additionalResultsLength = viewModel.allResults().length;
            viewModel.showMoreButton(false);
        } else {
            additionalResultsLength = viewModel.visibleResults().length + skip;
            viewModel.showMoreButton(true);
        }

        for (var i = viewModel.visibleResults().length; i < additionalResultsLength; i++) {
            viewModel.visibleResults.push(viewModel.allResults()[i]);
        }
    };

    viewModel.ViewAll = function () {
        if (viewModel.OfficeRelatedProfessionalsSeeAllUrl().length > 0) {
            window.location.href = viewModel.OfficeRelatedProfessionalsSeeAllUrl();
        }
    };

    // Apply Bindings
    ko.applyBindings(viewModel, pageContent.get(0));
};

},{}],4:[function(require,module,exports){
"use strict";

ko.bindingHandlers.bindRelatedList = {
    init: function init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var acInput = $(element);
        var observable = valueAccessor();
        var allBindings = allBindingsAccessor();

        var serviceUrl = allBindings.bindRelatedListServiceUrl;

        observable.IsSearchRunning = ko.observable(false);

        observable.LoadNextPage = function () {
            observable.SearchFilters.Skip(observable.GridData().length);
            observable.LoadDataFromServer();
        };

        observable.LoadDataFromServer = function () {
            observable.IsSearchRunning(true);
            $.ajax({
                url: serviceUrl,
                type: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.mapping.toJSON(observable.SearchFilters),
                cache: false,
                success: function success(data) {
                    var results = ko.observableArray();
                    ko.mapping.fromJS(data.GridData, {}, results);
                    ko.utils.arrayForEach(results(), function (item) {
                        observable.GridData.push(item);
                    });

                    observable.ResultCount(data.ResultCount);
                    observable.HasMoreResults(data.HasMoreResults);

                    observable.IsSearchRunning(false);
                },
                error: function error(xhr, textStatus, errorThrown) {
                    console.log(xhr.responseText);
                }
            });
        };
        observable.animateGridInsert = function (elem) {
            if (elem.nodeType === 1) $(elem).hide().fadeIn(800);
        };
        observable.animateGridDelete = function (elem) {
            if (elem.nodeType === 1) $(elem).fadeOut(800, function () {
                $(elem).remove();
            });
        };
    }
};

},{}],5:[function(require,module,exports){
'use strict';

require('./knockout/kolist.js');
require('./features/lazyload-images');
require('./features/email-disclaimer-modal');
require('./features/office-detail');

$('.js-binding-container').InitializePage({
    initialJsonData: initialJsonData,
    serviceUrl: "/api/sitecore/insights/search"
});

var lazy = $('.js-officeTeam').LazyImageLoader();
var modal = $('.js-disclaimerModal').Modal({
    triggerSelectors: ['.js-disclaimerModal-trigger'],
    dismissSelectors: ['.js-modalClose', '.js-modalButton-agree', '.js-modalButton-cancel']
});

},{"./features/email-disclaimer-modal":1,"./features/lazyload-images":2,"./features/office-detail":3,"./knockout/kolist.js":4}]},{},[5]);
